import { render, staticRenderFns } from "./BlogVideo.vue?vue&type=template&id=4f26bdad&scoped=true&"
import script from "./BlogVideo.vue?vue&type=script&lang=js&"
export * from "./BlogVideo.vue?vue&type=script&lang=js&"
import style0 from "./BlogVideo.vue?vue&type=style&index=0&id=4f26bdad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f26bdad",
  null
  
)

export default component.exports